var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"storeManage-list"},[_c('GlobalInfoBar',{attrs:{"title":"议价申请","content":"对小程序用户发起回收议价的处理列表"}}),_c('GlobalChunkNo',{attrs:{"icon":"search","title":"筛选查询"}},[_c('div',{attrs:{"slot":"filter"},slot:"filter"},[_c('storeManageFrom')],1),_c('storeManageTable')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }